import { useAuth } from '/@/core/auth'
import { useGenericModal } from '/@/core/modals/GenericModal'
import { __api as coreLoadingApi } from '/@/core/elements/loading'

/** Tells the person a later login elsewhere replaced this session, and has them log back in. */
export function showSupersededSessionModal() {
  const auth = useAuth()
  const genericModal = useGenericModal()
  // Hide the loading indicator (if present) to prevent it from blocking the modal
  coreLoadingApi.hide()

  genericModal.show({
    title: 'Oops!',
    content: `It looks like you're logged in on another device. To keep using Spoak on this device, log back in.`,
    btns: [
      {
        label: 'Log in',
        type: 'primary',
        async action() {
          await auth.logOut()
        },
      },
    ],
    strict: true,
  })
}
